import gsap from "gsap";

export default class SocialShareController {

    constructor() {
        this.init();
    }

    init() {

        let shareTrigger = document.querySelector(".js-social-share-trigger");
        let shareSingle = document.querySelectorAll(".js-social-share-single");

        if (shareTrigger === null) {
            return;
        }

        shareTrigger.addEventListener("click", (ev) => {
            ev.preventDefault();

            if (!shareTrigger.classList.contains("is-active")) {
                shareTrigger.classList.add("is-active");
                gsap.to(shareSingle, {
                    stagger: -0.05,
                    autoAlpha: 1,
                });
            } else {
                shareTrigger.classList.remove("is-active");
                gsap.to(shareSingle, {
                    stagger: 0.05,
                    autoAlpha: 0,
                });
            }

        });

    }

}
